<template>
    <div class="page">
      <Header/>
      <MatchInfo />
      <BasketBallHome />
      <Footer/>
    </div>
  </template>
  
<script>
import BasketBallHome from '@comm/components/match/basketball/BasketBallHome';
import MatchInfo from '@comm/components/MatchInfo.vue'
import Header from '@district/components/common/MatchHeader.vue'
import Footer from '@district/components/common/Footer'
export default {
  name: 'BasketBall',
  components: {
    Header,
    Footer,
    MatchInfo,
    BasketBallHome
  },
  data () {
    return {
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  mounted () {
  },
  methods: {
  }
}
</script>
  <style lang="scss" scoped>
  .page {
    width: 100%;
  }
  </style>
  


// WEBPACK FOOTER //
// src/district/views/project/components/BasketBall.vue